import { createSelector } from '@ngrx/store';
import { getMyZoneState, MyZoneState } from '../my-zone';
import * as fromInvoices from './invoices.reducer';

/** @deprecated moved to libs folder */
export const getInvoiceState = createSelector(getMyZoneState, (state: MyZoneState) => state.invoices);
/** @deprecated moved to libs folder */
export const getInvoiceEntities = createSelector(getInvoiceState, fromInvoices.getInvoiceEntities);
/** @deprecated moved to libs folder */
export const getInvoicePayments = createSelector(getInvoiceState, fromInvoices.getInvoicePayments);
/** @deprecated moved to libs folder */
export const getInvoiceCalculations = createSelector(getInvoiceState, fromInvoices.getInvoiceCalculations);
/** @deprecated moved to libs folder */
export const getInvoiceAdvances = createSelector(getInvoiceState, fromInvoices.getInvoiceAdvances);
/** @deprecated moved to libs folder */
export const getInvoiceLoading = createSelector(getInvoiceState, fromInvoices.getInvoiceLoading);
/** @deprecated moved to libs folder */
export const getInvoiceFormLoading = createSelector(getInvoiceState, fromInvoices.getInvoiceFormLoading);
/** @deprecated moved to libs folder */
export const getInvoiceIds = createSelector(getInvoiceState, fromInvoices.getInvoiceIds);
/** @deprecated moved to libs folder */
export const getInvoiceYears = createSelector(getInvoiceState, fromInvoices.getInvoiceYears);
/** @deprecated moved to libs folder */
export const getInvoiceSelectedYear = createSelector(getInvoiceState, fromInvoices.getInvoiceSelectedYear);
/** @deprecated moved to libs folder */
export const getInvoiceId = createSelector(getInvoiceState, fromInvoices.getInvoiceId);
/** @deprecated moved to libs folder */
export const getInvoicesLoaded = createSelector(getInvoiceState, fromInvoices.getLoadedInvoices);
/** @deprecated moved to libs folder */
export const getInvoicesYearsLoaded = createSelector(getInvoiceState, fromInvoices.getLoadedYears);
/** @deprecated moved to libs folder */
export const getInvoiceErrors = createSelector(getInvoiceState, fromInvoices.getInvoiceErrors);
/** @deprecated moved to libs folder */
export const getToPayIdeal = createSelector(getInvoiceState, fromInvoices.getToPayIdeal);
/** @deprecated moved to libs folder */
export const getToPayOnline = createSelector(getInvoiceState, fromInvoices.getToPayOnline);

/** @deprecated moved to libs folder */
export const getSelectedInvoice = createSelector(getInvoiceEntities, getInvoiceId, (entities, id) => entities[id]);
/** @deprecated moved to libs folder */
export const getSelectedInvoicePayment = createSelector(getInvoicePayments, getInvoiceId, (payments, id) => payments[id]);
/** @deprecated moved to libs folder */
export const getSelectedInvoiceCalculation = createSelector(getInvoiceCalculations, getInvoiceId, (calculations, id) => calculations[id]);
/** @deprecated moved to libs folder */
export const getSelectedInvoiceAdvance = createSelector(getInvoiceAdvances, getInvoiceId, (advances, id) => advances[id]);
/** @deprecated moved to libs folder */
export const getInvoicesCollection = createSelector(getInvoiceEntities, getInvoiceIds, (entities, ids) => ids.map(id => entities[id]));
/** @deprecated moved to libs folder */
export const getSelectedInvoicesByYear = createSelector(getInvoicesCollection, getInvoiceSelectedYear, (entities, year) => {
    return entities.filter((entity) => {
        return entity.factureringsdatum.split('-')[0].includes(`${year}`);
    });
});
/** @deprecated moved to libs folder */
export const getInvoicesPaymentsCollection = createSelector(getInvoicePayments, getInvoiceIds, (entities, ids) =>
    ids.map((id) => entities[id]));
/** @deprecated moved to libs folder */
export const getInvoicesPaymentsByYear = createSelector(getInvoicesPaymentsCollection, getInvoiceSelectedYear, (payments, year) => {
    return payments.filter((payment) => {
        if (payment !== undefined) {
            return payment.factureringsdatum.split('-')[0].includes(`${year}`);
        }
    });
});
